import styled from 'styled-components';

export const Tab = styled.div`
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    cursor: pointer;
    text-align: center;

    // transition: all ease-in 0.5s;

    color: white;
    font-size: 14px;
    font-weight: 200;

    &.active {
        box-sizing: content-box;
        border-bottom: 2px solid #f84c56;
        font-weight: 550;
    }
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Tab/style.js